export function pushTrackingData(data) {
    if (Object.keys(data).length === 0) {
        return;
    }

    const sanitizedData = sanitize(data);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(sanitizedData);
}

export function getTrackingData(el) {
    // Build tracking object
    const data = {};

    for (const [key, value] of Object.entries(el.dataset)) {
        // Filter tracking data
        if (key.startsWith("tracking") === false || key === "trackingEvent") {
            continue;
        }

        let sanitizedKey = key
            .replace('tracking', '')
            .match(/([A-Z]?[^A-Z]*)/g)
            .slice(0, -1)
            .join(" ")
            .replaceAll(" ", "_")
            .toLowerCase();

        data[sanitizedKey] = value;
    }

    return data;
}

function sanitize(data) {
    const sanitizedData = {
        'event': 'isc custom event'
    };

    for (const [key, value] of Object.entries(data)) {
        const valueOrDefault = typeof (value) === 'undefined' || value.length === 0 ? 'undefined' : value.toString();

        sanitizedData[`${key}`] = valueOrDefault;
    }

    return sanitizedData;
}